import src from "./handshake-animation.svg";

export function HandshakeAnimation(
    props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
) {
    return <img src={src} alt="" {...props} />;
}
